import type {Schemas} from 'domainTypes/dto';
import type {CompaniesCache} from '../types';

export const mapCompaniesDto = (
  dtos: Schemas.CompanyDto[],
  loadedProductOwnerIds: string[],
): CompaniesCache => ({
  companiesById: Object.fromEntries(dtos.map(dto => [dto.id, dto])),
  loadedIds: loadedProductOwnerIds,
});
